export default __webpack_public_path__ + "static/media/jerusalem2.ec753041.jpg";